export default __webpack_public_path__ + "static/media/tooltip-icon.a6c0ef4e.svg";